import { useEffect } from "react";
import AdminResourceTracker from "@/components/AdminResourceTracker";

export default function ToolShell({ title, tagline, description, slug, children }) {
  useEffect(() => {
    document.title = `${title} | Truestays`;
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("robots", "index, follow");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = `https://www.truestays.co.uk/resources/tools/${slug}`;

    const schema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: title,
      applicationCategory: "Calculator",
      operatingSystem: "Web",
      description,
      offers: { "@type": "Offer", price: "0", priceCurrency: "GBP" },
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "tool-schema";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { const el = document.getElementById("tool-schema"); if (el) el.remove(); };
  }, [title, description, slug]);

  return (
    <>
      <AdminResourceTracker page={`tool:${slug}`} />
      <section style={{
        backgroundColor: "#161616",
        paddingTop: "clamp(108px, 9vw, 140px)",
        paddingBottom: "clamp(32px, 4vw, 48px)",
        paddingLeft: "clamp(20px, 5vw, 80px)",
        paddingRight: "clamp(20px, 5vw, 80px)",
      }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)", marginBottom: 16, marginTop: 0 }}>Tools & Calculators</p>
          <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "clamp(30px, 4vw, 48px)", color: "#fff", margin: "0 0 14px", lineHeight: 1.1, letterSpacing: "-0.03em" }}>{title}</h1>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "clamp(16px, 1.8vw, 19px)", color: "rgba(255,255,255,0.7)", maxWidth: 620, margin: 0, lineHeight: 1.6 }}>{tagline}</p>
        </div>
      </section>
      <div style={{
        backgroundColor: "#F7F7F7",
        paddingTop: "clamp(40px, 5vw, 64px)",
        paddingBottom: "clamp(60px, 7vw, 96px)",
        paddingLeft: "clamp(20px, 5vw, 80px)",
        paddingRight: "clamp(20px, 5vw, 80px)",
      }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>{children}</div>
      </div>
    </>
  );
}